export function addPlaceholderBeforeGadget($gadget) {
  const $placeholder = document.createElement('dynamic-pdr-dashboard-gadget-placeholder')
  $placeholder.style.setProperty('--pdr-dashboard-gadget-columns', $gadget.columns)
  $placeholder.style.setProperty('--pdr-dashboard-gadget-rows', $gadget.rows)
  $gadget.insertAdjacentElement('beforebegin', $placeholder)

  return $placeholder
}
